import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}


export default {
    findcoa(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`coa/findcoa/${obj.kodeacc}/${obj.tahun}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    combo(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/inventorycategory/combo`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }
    ,
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get('/inventorycategory');
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }

    ,
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("inventorycategory", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
    ,
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`inventorycategory/${encodeURIComponent(obj.kodeacc)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }

};